var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "#b22234"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 48,
    height: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 14,
    fill: "#3c3b6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.92 2.1 2.88 3.45 4.8 3.45 3.36 4.68 3.84 6.45 1.92 5.4 0 6.45 0.48 4.68 -0.96 3.45 0.96 3.45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 3.84
  }), /*#__PURE__*/React.createElement("use", {
    x: 7.68
  }), /*#__PURE__*/React.createElement("use", {
    x: 11.52
  }), /*#__PURE__*/React.createElement("use", {
    x: 15.36
  })), /*#__PURE__*/React.createElement("use", {
    x: 1.92,
    y: 2.8
  }), /*#__PURE__*/React.createElement("use", {
    x: 5.76,
    y: 2.8
  }), /*#__PURE__*/React.createElement("use", {
    x: 9.6,
    y: 2.8
  }), /*#__PURE__*/React.createElement("use", {
    x: 13.44,
    y: 2.8
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 5.6
  }), /*#__PURE__*/React.createElement("use", {
    x: 3.84,
    y: 5.6
  }), /*#__PURE__*/React.createElement("use", {
    x: 7.68,
    y: 5.6
  }), /*#__PURE__*/React.createElement("use", {
    x: 11.52,
    y: 5.6
  }), /*#__PURE__*/React.createElement("use", {
    x: 15.36,
    y: 5.6
  }), /*#__PURE__*/React.createElement("use", {
    x: 1.92,
    y: 8.4
  }), /*#__PURE__*/React.createElement("use", {
    x: 5.76,
    y: 8.4
  }), /*#__PURE__*/React.createElement("use", {
    x: 9.6,
    y: 8.4
  }), /*#__PURE__*/React.createElement("use", {
    x: 13.44,
    y: 8.4
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 11.2
  }), /*#__PURE__*/React.createElement("use", {
    x: 3.84,
    y: 11.2
  }), /*#__PURE__*/React.createElement("use", {
    x: 7.68,
    y: 11.2
  }), /*#__PURE__*/React.createElement("use", {
    x: 11.52,
    y: 11.2
  }), /*#__PURE__*/React.createElement("use", {
    x: 15.36,
    y: 11.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.e47574e6ab1796de90632c591a49d67a.svg";
export { ForwardRef as ReactComponent };